import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { ProtectedRoute } from '@/auth';
import { AppShell } from '@/components/layout';
import { AdminPage } from '@/pages/Admin/AdminPage';
import { AlgorithmPage } from '@/pages/Algorithm/AlgorithmPage';
import { DashboardPage } from '@/pages/Dashboard/DashboardPage';
import { LoginPage } from '@/pages/Login/LoginPage';
import { OpportunityDetailPage } from '@/pages/OpportunityDetail/OpportunityDetailPage';
import { ReportingPage } from '@/pages/Reporting/ReportingPage';
import { StatsPage } from '@/pages/Stats/StatsPage';
import { UnauthorizedPage } from '@/pages/Unauthorized/UnauthorizedPage';

/**
 * Redirect the index route to the opportunities list, carrying the query
 * string with it (T20-3323).
 *
 * `<Navigate to="/opportunities" />` drops the search params, which silently
 * breaks any shared link copied from the root URL -- filters, sort and page
 * all vanish on arrival.
 */
function IndexRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/opportunities${search}`} replace />;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<IndexRedirect />} />
        <Route path="opportunities" element={<DashboardPage />} />
        <Route path="map" element={<DashboardPage />} />
        <Route path="opportunities/:id" element={<OpportunityDetailPage />} />
        <Route
          path="stats"
          element={
            <ProtectedRoute requiredRoles={['admin']}>
              <StatsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="reporting"
          element={
            <ProtectedRoute requiredRoles={['vp', 'admin']}>
              <ReportingPage />
            </ProtectedRoute>
          }
        />
        <Route path="algorithm" element={<AlgorithmPage />} />
        <Route
          path="admin"
          element={
            <ProtectedRoute requiredRoles={['admin']}>
              <AdminPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
